import Role from './enums';

export const HmrcDataBranchValues = {
  On: 'master_hmrc_data',
  Off: 'master_no_hmrc_data',
} as const;

export type HmrcDataBranch = typeof HmrcDataBranchValues[keyof typeof HmrcDataBranchValues];

export type HmrcDataToggle = {
  isDisplayed: boolean;
  isEnabled: boolean;
  branch: HmrcDataBranch;
  expiresAt: string | null;
};

export type User = {
  firstName: string;
  lastName: string;
  organisationDisplayName: string
  role: Role;
  email: string;
  hmrcDataToggle: HmrcDataToggle;
};

export interface DisplayOrganisationUser {
  lastName: string;
  firstName: string;
  role: Role;
  email: string;
}

export interface ComponentProps {
  id: string;
  className?: string;
}

export interface OrganisationNames {
  organisationNames: string[]
}

export type ViewAsResponse = {
  temporaryOrganisationName: string;
  temporaryRoleName: string;
};

export type Snapshot = {
  rawSnapshot: string;
  formattedSnapshot: string;
};

export interface RolesAndOrganisations {
  roles: string[];
  organisations: string[];
}
